export default __webpack_public_path__ + "static/FirstsafetyBanner-dd6b2fa14b7152e0a722859ff630d02f.webp";